/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-unresolved */
import { Grid, Box, Button, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { validationSchema } from '@/utils/helpers';
import Input from '@/components/Forms/Input';
import Select from '@/components/Forms/Select';
import { useFetchPosProfileDetails } from '@/services/hooks';
import { selectPrinter } from '@/store/selectors';
import { updateKOTPrinter, PrinterKOTType } from '@/store/slices/printer';
import { closeModal } from '@/store/slices/modal';

let area = [
  {
    name: 'None',
  },
];

let areaArr: any[] = [];

let initialState: Omit<PrinterKOTType, 'name'> = {
  ipAddress: '',
  area: '',
  port: '',
};

const AddPrinterForm = () => {
  const { currentName, kot, currentKOTIP } = useSelector(selectPrinter);
  const { data } = useFetchPosProfileDetails();
  const dispatch = useDispatch();

  const kotPrinter = kot?.find((item) => item.ipAddress === currentKOTIP);

  if (data?.map_kot_print_areas) {
    areaArr = data?.map_kot_print_areas.map((print_area: any) => ({
      name: print_area.print_area,
    }));
  }

  // Sort Area
  area = areaArr?.filter(
    (obj, index, self) =>
      self.findIndex((item) => item.name === obj.name) === index,
  );

  let selectedPrinter;

  if (
    currentName === 'KOT Printer' &&
    kotPrinter?.ipAddress === currentKOTIP &&
    kotPrinter
  ) {
    selectedPrinter = kotPrinter;
  }

  if (selectedPrinter) {
    initialState = {
      ipAddress:
        selectedPrinter.ipAddress === 'None' ? '' : selectedPrinter.ipAddress,
      port: selectedPrinter.port === 'None' ? '' : selectedPrinter.port,
      area: selectedPrinter.area === 'None' ? '' : selectedPrinter.area,
    };
  }

  const { dynamic } = validationSchema;

  const handleSubmit = (values: typeof initialState) => {
    const printerObj = {
      name: currentName,
      ipAddress: values.ipAddress,
      port: values.port,
      area: values.area,
    };
    dispatch(updateKOTPrinter(printerObj));

    dispatch(closeModal({ type: 'KOTPrinter' }));
  };

  return (
    <Box mt={6}>
      <Formik
        initialValues={initialState}
        onSubmit={handleSubmit}
        validationSchema={yup.object({
          ipAddress: dynamic('IP Address is required'),
          port: dynamic('Port is required'),
          area: dynamic('Area is required'),
        })}
      >
        <Form>
          <Typography textAlign="left" mb={3}>
            This printer will be automatically used when other printers are not
            available
          </Typography>
          <Grid container rowSpacing={4}>
            <Select name="area" label="Select Area" item={area} />
            <Input
              name="ipAddress"
              type="text"
              label="Enter Printer IP"
              size={12}
            />
            <Input
              name="port"
              type="text"
              label="Enter Printer Port"
              size={12}
            />

            <Grid item xs={12} marginTop={5} sx={{ mx: 'auto' }}>
              <Button
                type="submit"
                variant="contained"
                sx={{ borderRadius: 2 }}
              >
                Save Printer
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Box>
  );
};

export default AddPrinterForm;
